import TYPES from '@/types';

// Application
import GetCustomerOverviewQuery from '@/modules/home-dashboard/customer-overview/application/queries/get-customer-overview-query';

// Domain
import Inject from '@/modules/shared/domain/di/inject';
import Translator from '@/modules/shared/domain/i18n/translator';
import { Values } from '@/modules/shared/domain/i18n/types';
import { MessageNotifier } from '@/modules/shared/domain/notifiers/message_notifier';
import { DateFormatter } from '@/modules/shared/domain/date-formatters';

export default class MyInvestmentDashboardViewModelV2 {
  @Inject(TYPES.GET_CUSTOMER_OVERVIEW_QUERY)
  private readonly get_customer_overview!: GetCustomerOverviewQuery;

  @Inject(TYPES.DATE_FORMATTER)
  readonly date_formatter!: DateFormatter;

  @Inject(TYPES.I18N)
  readonly translator!: Translator;

  @Inject(TYPES.NOTIFIER)
  private readonly message_notifier!: MessageNotifier;

  readonly i18n_namespace = 'components.my-investment-dashboard';

  wealth_policy_in_process_of_cancellation = false;

  open_update_personality_profile_notification = false;

  years_without_updating = 0;

  overview_loaded = false;

  translate = (message: string, values?: Values) => this.translator.translate(`${this.i18n_namespace}.${message}`, values);

  setTitleOfWindow = () => {
    const set_title_event = new CustomEvent('nav-bar.title', {
      detail: {
        title: [
          {
            label: this.translate('title'),
          },
        ],
      },
    });
    window.dispatchEvent(set_title_event);
  }

  loadCustomerOverview = async () => {
    try {
      const customer_overview = await this
        .get_customer_overview.execute();
      this.overview_loaded = true;
      this.wealth_policy_in_process_of_cancellation = customer_overview
        .wealth_investment_product_overview.contracting_status === 'cancelation';
      if (customer_overview.investor_profile_overview.update_required) {
        this.years_without_updating = customer_overview.investor_profile_overview
          .years_without_updating;
        this.loadPersonalityProfile();
      }
    } catch (error) {
      this.message_notifier.showErrorNotification(this.translate('errors.load_overview'));
    }
  }

  loadPersonalityProfile = () => {
    const modal_was_already_showed = sessionStorage.getItem('update_profile_personality_notification_dialog_was_already_showed');
    if (!modal_was_already_showed) {
      this.open_update_personality_profile_notification = true;
      sessionStorage.setItem('update_profile_personality_notification_dialog_was_already_showed', 'false');
    }
  }

  initialize = async () => {
    this.setTitleOfWindow();
    await this.loadCustomerOverview();
  }
}
